import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";
import { ArrowUpRight } from "lucide-react";

export const GWRStrip = () => {
  const { t } = useLang();
  const g = t.gwr;
  return (
    <section className="relative overflow-hidden bg-red-brand py-16 sm:py-20" data-testid="gwr-section">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 lg:grid-cols-12 gap-10 items-center px-5 sm:px-8">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono-tech text-[0.7rem] tracking-[0.28em] uppercase text-[#f8f7f4]/70" data-testid="gwr-eyebrow">
              {g.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-[1.05] text-[#f8f7f4]" data-testid="gwr-title">
              {g.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 max-w-xl text-sm sm:text-base leading-relaxed text-[#f8f7f4]/80">{g.desc}</p>
          </Reveal>
          <Reveal delay={0.22}>
            <a
              data-testid="gwr-chip"
              href="https://amperi.eu"
              target="_blank"
              rel="noopener noreferrer"
              className="chamfer-sm mt-7 inline-flex items-center gap-2 border border-[#f8f7f4]/35 px-4 py-2 font-mono-tech text-[10px] font-semibold uppercase tracking-[0.18em] text-[#f8f7f4] transition-colors duration-200 hover:bg-[#f8f7f4] hover:text-red-brand"
            >
              {g.chip}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <figure className="chamfer relative overflow-hidden border border-[#f8f7f4]/30">
              <img
                src="/assets/img/gwr-amperi.webp"
                alt={g.caption}
                data-testid="gwr-photo"
                className="h-52 sm:h-60 w-full object-cover transition-transform duration-700 hover:scale-[1.04]"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#16181b]/75 to-transparent px-4 pt-8 pb-3 font-mono-tech text-[9px] uppercase tracking-[0.15em] text-[#f8f7f4]/85">
                {g.caption}
              </figcaption>
            </figure>
          </Reveal>
          {g.mototrip && (
            <Reveal delay={0.1}>
              <p className="mt-5 border-l-2 border-[#f8f7f4]/40 pl-4 text-sm leading-relaxed text-[#f8f7f4]/80" data-testid="gwr-mototrip">
                {g.mototrip}{" "}
                <a href="https://biurorekordow.pl/event/electric-mototrip-motocyklami-elektrycznymi-dookola-polski/" target="_blank" rel="noopener noreferrer" data-testid="gwr-mototrip-link" className="font-mono-tech text-[10.5px] uppercase tracking-[0.15em] text-[#f8f7f4] underline underline-offset-4 decoration-[#f8f7f4]/40 hover:decoration-[#f8f7f4]">
                  {g.mototripCta} ↗
                </a>
              </p>
            </Reveal>
          )}
          <div className="mt-4 grid grid-cols-3 gap-px border border-[#f8f7f4]/25 bg-[#f8f7f4]/25">
            {g.stats.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08} className="bg-red-brand p-5 sm:p-6">
                <div className="font-display text-2xl sm:text-3xl font-black tracking-tight text-[#f8f7f4]" data-testid={`gwr-stat-${i}`}>
                  {s.val}
                </div>
                <div className="mt-1.5 font-mono-tech text-[9px] uppercase tracking-[0.14em] text-[#f8f7f4]/60">{s.label}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
